export const CREATE_PROGRAM = "CREATE_PROGRAM";
export const UPDATE_PROGRAM = "UPDATE_PROGRAM";
export const DELETE_PROGRAM = "DELETE_PROGRAM";
export const FETCH_PROGRAMS = "FETCH_PROGRAMS";
export const LISTEN_TO_SELECTED_PROGRAM = "LISTEN_TO_SELECTED_PROGRAM";
